import SecondaryCamera from './SecondaryCamera';

export default SecondaryCamera;
